<template>
  <div>
    <h4 class="mb-1">
      Серые профили
    </h4>
    <p class="text-muted">
      Неактивированные профили без возможности входа.
    </p>
    <b-alert
      v-if="errorText"
      show
      variant="danger"
    >
      {{ errorText }}
    </b-alert>
    <b-card no-body>
      <b-card-body>
        <div class="d-flex flex-wrap mb-1">
          <b-form-input
            v-model="filterText"
            class="mb-1 mr-1"
            placeholder="Поиск по имени"
            @keyup.enter="fetch"
          />
          <b-form-group
            class="mb-1 mr-1"
            label="Создан с"
            label-for="grey-created-from"
            description="Серые профили, созданные не раньше этой даты"
          >
            <b-form-input
              id="grey-created-from"
              v-model="createdFrom"
              type="date"
              @change="fetch"
            />
          </b-form-group>
          <b-form-group
            class="mb-1 mr-1"
            label="Создан по"
            label-for="grey-created-to"
            description="Серые профили, созданные не позже этой даты"
          >
            <b-form-input
              id="grey-created-to"
              v-model="createdTo"
              type="date"
              @change="fetch"
            />
          </b-form-group>
          <b-form-input
            v-model="minAge"
            class="mb-1 mr-1"
            placeholder="Возраст от"
            @keyup.enter="fetch"
          />
          <b-form-input
            v-model="maxAge"
            class="mb-1 mr-1"
            placeholder="Возраст до"
            @keyup.enter="fetch"
          />
          <b-form-checkbox
            v-model="duplicatesOnly"
            class="mb-1 mr-1"
            @change="fetch"
          >
            Только дубли
          </b-form-checkbox>
          <b-button
            variant="primary"
            class="mb-1"
            @click="fetch"
          >
            Найти
          </b-button>
        </div>
        <b-table
          :items="rows"
          :fields="fields"
          :busy="loading"
          striped
          responsive
          empty-text="Серых профилей нет"
        >
          <template #cell(canLogin)>
            Нет
          </template>
          <template #cell(actions)="data">
            <b-button
              v-if="data.item.hasContact"
              size="sm"
              variant="outline-primary"
              @click="invite(data.item)"
            >
              Пригласить активировать
            </b-button>
          </template>
          <template #table-busy>
            <div class="text-center my-2">
              <b-spinner small /> Загрузка...
            </div>
          </template>
        </b-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BAlert,
  BButton,
  BCard,
  BCardBody,
  BFormCheckbox,
  BFormGroup,
  BFormInput,
  BSpinner,
  BTable,
} from 'bootstrap-vue'
import identityApi from '@/services/identity-api.service'

export default {
  name: 'GreyProfilesPage',
  components: {
    BAlert,
    BButton,
    BCard,
    BCardBody,
    BFormCheckbox,
    BFormGroup,
    BFormInput,
    BSpinner,
    BTable,
  },
  data() {
    return {
      loading: false,
      errorText: '',
      filterText: '',
      createdFrom: '',
      createdTo: '',
      minAge: '',
      maxAge: '',
      duplicatesOnly: false,
      skipCount: 0,
      rows: [],
      fields: [
        { key: 'id', label: 'ID' },
        { key: 'surname', label: 'Фамилия' },
        { key: 'name', label: 'Имя' },
        { key: 'birthday', label: 'Дата рождения' },
        { key: 'age', label: 'Возраст' },
        { key: 'account_status', label: 'Статус' },
        { key: 'registrationsCount', label: 'Регистрации' },
        { key: 'resultsCount', label: 'Результаты' },
        { key: 'duplicatesIndicator', label: 'Дубли' },
        { key: 'canLogin', label: 'Вход' },
        { key: 'actions', label: 'Действия' },
      ],
    }
  },
  created() {
    this.fetch()
  },
  methods: {
    async fetch() {
      this.loading = true
      this.errorText = ''
      try {
        const { data } = await identityApi.getGreyProfiles({
          filterText: this.filterText,
          createdFrom: this.createdFrom || undefined,
          createdTo: this.createdTo || undefined,
          minAge: this.minAge || undefined,
          maxAge: this.maxAge || undefined,
          duplicatesOnly: this.duplicatesOnly || undefined,
          skipCount: this.skipCount,
          maxResultCount: 50,
        })
        this.rows = data.rows || []
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось загрузить серые профили'
      } finally {
        this.loading = false
      }
    },
    async invite(item) {
      try {
        await identityApi.inviteGreyActivate(item.id)
        this.$bvToast.toast('Приглашение отправлено', { variant: 'success', title: 'Серый профиль' })
      } catch (e) {
        this.errorText = e.response?.data?.message || 'Не удалось отправить приглашение'
      }
    },
  },
}
</script>
